import { DatePicker as DatePickerComponent } from '@mui/x-date-pickers/DatePicker'
import styled, { css } from 'styled-components'
import { TextFieldComponent } from '../TextFieldComponent'

export const Calendar = styled(DatePickerComponent)(
  ({ theme }) => css`
    && {
      label {
        font-size: ${theme.typograph.fontsize.h3};
        padding: 0 ${theme.layout.padding.small};
        background: ${theme.colors.base.white};
      }
      .MuiInputBase-root {
        .MuiInputBase-input {
          font-size: ${theme.typograph.fontsize.h3};
        }
        .MuiSvgIcon-root {
          width: ${theme.layout.iconSize.medium};
          height: ${theme.layout.iconSize.medium};
        }
      }
    }
  `
)

export const DateField = styled(TextFieldComponent)(
  ({ theme }) => css`
    && {
      width: 100%;

      .MuiInputLabel-root {
        font-size: ${theme.typograph.fontsize.h3};
      }

      .MuiOutlinedInput-input {
        font-size: ${theme.typograph.fontsize.h3};
        padding: ${theme.layout.padding.base * 2 + 0.05}rem
          ${theme.layout.padding.medium};
        padding-right: 0;
      }

      .MuiButtonBase-root {
        padding-left: 0;
      }
    }
  `
)
